import React from 'react';
import HeroSection from './HeroSection';
import VideoSection from './VideoSection';
import TimelineSection from './TimelineSection';
import HeroSection2 from './HeroSection2';
import TimelineSection2 from './TimelineSection2';
import Footer from '../../components/Footer';
const LandingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <VideoSection />
      <TimelineSection />
      <HeroSection2 />
      <TimelineSection2 />
      <Footer />
    </div>
  );
};

export default LandingPage;
